import { Sorter } from '../../../../components/Sorter/Sorter'
import { SortOrder } from 'antd/es/table/interface'
import { ColumnsType } from 'antd/es/table'
import { ICCHealthSystemWithHospitals } from '../types'

export const columns = (
  canSeeHealthSystem: boolean
): ColumnsType<ICCHealthSystemWithHospitals> => [
  {
    dataIndex: 'name',
    key: 'name',
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<ICCHealthSystemWithHospitals>
        dataIndex="name"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        {canSeeHealthSystem ? 'Health system' : 'Hospital'}
      </Sorter>
    ),
    sorter: true,
    showSorterTooltip: false,
    render: (_, { name }) => <span className="name-column">{name}</span>
  }
]
